import React from 'react';

import { Currencies } from '@constants/constants';
import Typography from '@components/Typography';
import { getCurrencySymbol } from '@utils/utils';

import { Discount } from './DiscountLabelStyle';

interface DiscountLabelProps {
  discount: number | string;
  type?: 'percent' | 'value';
  currency?: string;
}

const DiscountLabel = ({
  discount,
  type = 'percent',
  currency = Currencies.TL,
}: DiscountLabelProps) => (
  <Discount>
    <Typography variant='caption2' weight='SemiBold' color='NL0' as='div'>
      {type === 'percent' ? '%' : ''}
      {discount} {type === 'value' ? getCurrencySymbol(currency) : ''}
    </Typography>{' '}
    <div>
      <Typography variant='caption3' weight='SemiBold' color='NL0'>
        {type !== 'value' ? 'İndirim' : ''}
      </Typography>
    </div>
  </Discount>
);

export default DiscountLabel;
